import { CaretLeft, CaretRight, Timer, Warning } from "@phosphor-icons/react";
import { fmtBRL, fmtInt, devCountdown, orderCupsCount } from "@/lib/api";
import { overdueDays } from "./kanbanUtils";

export default function KanbanCard({
  o, canAdmin, selectionMode, isSelected, isDragging, isHighlighted,
  canGoBack, canGoForward,
  onDragStart, onDragEnd, onClick, onToggleSelect, onArrowMove,
}) {
  const late = overdueDays(o);
  const dev = devCountdown(o);
  const devLate = dev.applies && dev.days_overdue > 0;
  const devPending = dev.applies && dev.days_remaining > 0;

  return (
    <div
      className={`kanban-card ${isDragging ? "dragging" : ""} ${isHighlighted ? "kanban-card-highlight" : ""} ${(late > 0 || devLate) && !isHighlighted ? "kanban-card-late" : ""} ${selectionMode && isSelected ? "ring-2 ring-black" : ""}`}
      draggable={!selectionMode}
      onDragStart={() => !selectionMode && onDragStart(o)}
      onDragEnd={onDragEnd}
      onClick={() => onClick(o)}
      data-testid={`kanban-card-${o.bling_number}`}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 min-w-0">
          {selectionMode && (
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => { e.stopPropagation(); onToggleSelect(o, e.target.checked); }}
              onClick={(e) => e.stopPropagation()}
              className="w-4 h-4 accent-black cursor-pointer flex-shrink-0"
              data-testid={`kanban-check-${o.bling_number}`}
            />
          )}
          <div className="font-mono text-sm font-bold">#{o.bling_number}</div>
        </div>
        <div className="text-[10px] overline bg-black text-white px-2 py-0.5">{o.marketplace?.slice(0, 12) || "—"}</div>
      </div>
      <div className="text-sm font-semibold truncate mb-1">{o.customer}</div>
      <div className="text-xs text-zinc-500">
        {fmtInt(orderCupsCount(o))} copos · {o.silk_color || "sem silk"}
      </div>
      <div className="mt-2 flex items-center justify-between gap-2 flex-wrap">
        {canAdmin && (
          <span className="text-xs font-mono text-[#00A300]" data-testid={`kanban-liquido-${o.bling_number}`}>{fmtBRL(o.net_value)}</span>
        )}
        {devPending && (
          <span
            className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-black text-white px-2 py-0.5"
            data-testid={`dev-countdown-${o.bling_number}`}
            title={`Prazo de desenvolvimento: 5 dias após entrada no sistema`}
          >
            <Timer size={11} weight="fill" /> {dev.days_remaining}d dev
          </span>
        )}
        {devLate && (
          <span
            className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-[#E60000] text-white px-2 py-0.5"
            data-testid={`dev-overdue-${o.bling_number}`}
          >
            <Warning size={11} weight="fill" /> dev atrasado {dev.days_overdue}d
          </span>
        )}
        {late > 0 && (
          <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-[#E60000] text-white px-2 py-0.5" data-testid={`overdue-badge-${o.bling_number}`}>
            <Warning size={11} weight="fill" /> {late}d atraso
          </span>
        )}
      </div>
      {o.exit_date && (
        <div className={`mt-1 text-[10px] font-mono ${late > 0 ? "text-[#E60000] font-bold" : "text-zinc-400"}`}>
          limite: {new Date(o.exit_date.slice(0, 10) + "T12:00:00").toLocaleDateString("pt-BR")}
        </div>
      )}
      {/* Setinhas para navegar entre colunas sem arrastar */}
      <div className="mt-2 pt-2 border-t border-zinc-200 flex items-center justify-between">
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onArrowMove(o, -1); }}
          disabled={!canGoBack}
          className="p-1 -m-1 text-zinc-500 hover:text-black disabled:opacity-30 disabled:cursor-not-allowed"
          title="Voltar uma etapa"
          data-testid={`kanban-back-${o.bling_number}`}
        >
          <CaretLeft size={18} weight="bold" />
        </button>
        <span className="text-[9px] uppercase tracking-widest text-zinc-400">mover</span>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onArrowMove(o, +1); }}
          disabled={!canGoForward}
          className="p-1 -m-1 text-zinc-500 hover:text-black disabled:opacity-30 disabled:cursor-not-allowed"
          title="Avançar uma etapa"
          data-testid={`kanban-forward-${o.bling_number}`}
        >
          <CaretRight size={18} weight="bold" />
        </button>
      </div>
    </div>
  );
}
